import { Wrapper, ModalWrapper } from './ActionsLayout.styled'

export enum ActionsLayoutVariant {
  Base,
  Modal,
}

export type ActionsLayoutProps = {
  direction?: 'right' | 'left' | 'spaceBetween'
  variant?: ActionsLayoutVariant
  dataTest?: string
}

const ActionsLayout: React.FC<ActionsLayoutProps> = props => {
  const {
    children,
    variant = ActionsLayoutVariant.Base,
    direction = 'right',
    dataTest = 'ActionsLayout',
  } = props

  switch (variant) {
    case ActionsLayoutVariant.Modal:
      return <ModalWrapper data-test={dataTest}>{children}</ModalWrapper>
    case ActionsLayoutVariant.Base:
    default:
      return (
        <Wrapper direction={direction} data-test={dataTest}>
          {children}
        </Wrapper>
      )
  }
}

export default ActionsLayout
